/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/forum/app';
import FacadeListState from '../states/BannerListState';
import BannerListItem from './BannerListItem';
import BannerListToolbar from './BannerListToolbar';

const t = app.translator.trans.bind(app.translator);

export default class BannerList extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		this.state = new FacadeListState({
			sort: m.route.param('sort'),
			filter: m.route.param('filter'),
		});

		this.state.refresh();
	}

	view() {
		const state = this.state;

		let loading;

		if (state.isInitialLoading() || state.isLoadingNext()) {
			loading = <LoadingIndicator />;
		} else if (state.hasNext()) {
			loading = (
				<Button className="Button" onclick={state.loadNext.bind(state)}>
					{t('core.forum.discussion_list.load_more_button')}
				</Button>
			);
		}

		return (
			<div className="BannerList">
				<BannerListToolbar state={state} />
				<ul className="BannerList-list">
					{state.getPages().map((pg) => {
						return pg.items.map((banner) => (
							<li className="BannerList-item">
								<BannerListItem banner={banner} />
							</li>
						));
					})}
					{/* {state.isEmpty() && <BookshelvesListItemEmpty />} TODO */}
				</ul>
				<div className="BannerList-loadMore">{loading}</div>
			</div>
		);
	}
}
